import React, { useState } from 'react';
import s from './PlanFaq.scss';
import AccordionWrapper from './AccordionWrapper';
import AccordionItem from './AccordionItem';

const PlanFaq = props => {
  const { faq, supportData, isWapView } = props;
  const [showFaqsItems, setShowAllFaqItems] = useState(false);
  const fqaLoadMore = () => {
    setShowAllFaqItems(true);
  };

  const getFaqAccodian = (item, index) => {
    if (showFaqsItems) {
      return (
        <AccordionItem
          key={index}
          index={index}
          title={item.que}
          content={item.ans}
        />
      );
    } else if (index < 4) {
      return (
        <AccordionItem
          key={index}
          index={index}
          title={item.que}
          content={item.ans}
        />
      );
    }
    return null;
  };

  return (
    <>
      <div className={s.faqsdiv}>
        <div className="contentwrapper">
          {faq?.h1 && <h3>{faq?.h1}</h3>}
          <div className={s.que_ans}>
            <AccordionWrapper>
              {faq?.qna &&
                faq?.qna.map((item, index) => getFaqAccodian(item, index))}
            </AccordionWrapper>

            {faq &&
              faq?.cta &&
              !showFaqsItems && (
                <span className={s.more_btn} onClick={fqaLoadMore}>
                  <span>{faq?.cta}</span>
                </span>
              )}
          </div>
          {isWapView &&
            supportData && (
              <p
                className={s.needHelp}
                dangerouslySetInnerHTML={{
                  __html: unescape(supportData),
                }}
              />
            )}
          {!isWapView &&
            supportData &&
            showFaqsItems && (
              <p
                className={s.needHelp}
                dangerouslySetInnerHTML={{
                  __html: unescape(supportData),
                }}
              />
            )}
        </div>
      </div>
    </>
  );
};

export default PlanFaq;
